import styles from '../styles.module.scss';
import skeleton from './styles.module.scss';

export default function BetInfoSkeleton() {
  return (
    <div className={styles.container}>
      <div className={skeleton.image} />

      <div className={styles.container__column}>
        <div className={styles.container__row}>
          <div
            className={skeleton.text}
            style={{
              width: '40px',
            }}
          />

          <div
            className={skeleton.text}
            style={{
              width: '100px',
            }}
          />
        </div>

        <div className={skeleton.text} />

        <div className={styles.container__row}>
          <div
            className={skeleton.text}
            style={{
              width: '50px',
            }}
          />

          <div className={skeleton.icon} />

          <div
            className={skeleton.text}
            style={{
              width: '100px',
            }}
          />

          <div className={skeleton.icon} />
        </div>
      </div>
    </div>
  );
}
